import React, { useEffect } from 'react';
import { bool, func, node, object, shape, string } from 'prop-types';
import ListingsCarousel from '../../../ListingPage/ListingsCarousel/ListingsCarousel';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { getListingsById } from '../../../../ducks/marketplaceData.duck';
import css from './SectionNewestListings.module.css';
import SectionContainer from '../SectionContainer';
import Field, { hasDataInFields } from '../../Field';
import classNames from 'classnames';

const SectionNewestListings = props => {
  const {
    listings,
    title,
    description,
    callToAction,
    className,
    rootClassName,
    titleClassName,
    appearance,
    sectionId,
    options,
    descriptionClassName,
  } = props;
  // If external mapping has been included for fields
  // E.g. { h1: { component: MyAwesomeHeader } }
  const fieldComponents = options?.fieldComponents;
  const fieldOptions = { fieldComponents };

  const hasHeaderFields = hasDataInFields([title, description, callToAction], fieldOptions);
  return (
    <SectionContainer
      id={sectionId}
      className={classNames(className, css.sectionContent)}
      rootClassName={classNames(rootClassName, css.root)}
      appearance={appearance}
      options={fieldOptions}
    >
      {hasHeaderFields ? (
        <header className={css.sectionDetails}>
          <Field
            data={title}
            className={classNames(css.title, titleClassName)}
            options={fieldOptions}
          />
          <Field
            data={description}
            className={classNames(css.description, descriptionClassName)}
            options={fieldOptions}
          />
        </header>
      ) : null}
      <ListingsCarousel
        {...props}
        className={css.carouselBlock}
        titleClassName={css.title}
        blocks={listings}
      />
    </SectionContainer>
  );
};

const propTypeOption = shape({
  fieldComponents: shape({ component: node, pickValidProps: func }),
});

SectionNewestListings.defaultProps = {
  className: null,
  rootClassName: null,
  defaultClasses: null,
  textClassName: null,
  title: null,
  description: null,
  appearance: null,
  callToAction: null,
  isInsideContainer: false,
  options: null,
};

SectionNewestListings.propTypes = {
  sectionId: string.isRequired,
  className: string,
  rootClassName: string,
  defaultClasses: shape({
    sectionDetails: string,
    title: string,
    description: string,
    ctaButton: string,
  }),
  title: object,
  description: object,
  appearance: object,
  callToAction: object,
  isInsideContainer: bool,
  options: propTypeOption,
};

const mapStateToProps = state => {
  const { newestListing } = state.PageBuilder;

  const listings = getListingsById(state, newestListing.resultIds);
  return { listings };
};

export default compose(connect(mapStateToProps))(SectionNewestListings);
